'use strict';
import * as $j_app$002eapi$002e$002dClient$002dType from "./app.api.-Client-Type.js";
import * as $j_app$002eapi$002e$002dClient$002dType$0024$0024anon$00241 from "./app.api.-Client-Type$$anon$1.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_ClientType$namedEnum$() {
  this.Lapp_api_ClientType$namedEnum$__f_byName = null;
  this.Lapp_api_ClientType$namedEnum$__f_values$lzy1 = null;
  this.Lapp_api_ClientType$namedEnum$__f_valuesbitmap$1 = false;
  $n_Lapp_api_ClientType$namedEnum$ = this;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lframework_utils_NamedEnum__$init$__V(this);
}
export { $c_Lapp_api_ClientType$namedEnum$ as $c_Lapp_api_ClientType$namedEnum$ };
$c_Lapp_api_ClientType$namedEnum$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_ClientType$namedEnum$.prototype.constructor = $c_Lapp_api_ClientType$namedEnum$;
/** @constructor */
function $h_Lapp_api_ClientType$namedEnum$() {
}
export { $h_Lapp_api_ClientType$namedEnum$ as $h_Lapp_api_ClientType$namedEnum$ };
$h_Lapp_api_ClientType$namedEnum$.prototype = $c_Lapp_api_ClientType$namedEnum$.prototype;
$c_Lapp_api_ClientType$namedEnum$.prototype.byName__sci_Map = (function() {
  return this.Lapp_api_ClientType$namedEnum$__f_byName;
});
$c_Lapp_api_ClientType$namedEnum$.prototype.framework$utils$NamedEnum$_setter_$byName_$eq__sci_Map__V = (function(x$0) {
  this.Lapp_api_ClientType$namedEnum$__f_byName = x$0;
});
$c_Lapp_api_ClientType$namedEnum$.prototype.values__sci_Vector = (function() {
  if ((!this.Lapp_api_ClientType$namedEnum$__f_valuesbitmap$1)) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_NonEmptyVector$();
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($m_Lapp_api_ClientType$().values__ALapp_api_ClientType());
    this.Lapp_api_ClientType$namedEnum$__f_values$lzy1 = $x_1.fromVectorUnsafe__sci_Vector__sci_Vector($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$2));
    this.Lapp_api_ClientType$namedEnum$__f_valuesbitmap$1 = true;
  }
  return this.Lapp_api_ClientType$namedEnum$__f_values$lzy1;
});
$c_Lapp_api_ClientType$namedEnum$.prototype.toName__Lapp_api_ClientType__T = (function(a) {
  var x = $s_Lapp_api_ClientType$__DesktopBrowser__Lapp_api_ClientType();
  if ((x === a)) {
    return "DesktopBrowser";
  }
  var x$3 = $s_Lapp_api_ClientType$__MobileBrowser__Lapp_api_ClientType();
  if ((x$3 === a)) {
    return "MobileBrowser";
  }
  var x$5 = $s_Lapp_api_ClientType$__Tauri__Lapp_api_ClientType();
  if ((x$5 === a)) {
    return "Tauri";
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(a);
});
$c_Lapp_api_ClientType$namedEnum$.prototype.toName__O__T = (function(a) {
  return this.toName__Lapp_api_ClientType__T(a);
});
var $d_Lapp_api_ClientType$namedEnum$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_ClientType$namedEnum$, "app.api.ClientType$namedEnum$", ({
  Lapp_api_ClientType$namedEnum$: 1,
  Lframework_utils_NamedEnum: 1
}));
export { $d_Lapp_api_ClientType$namedEnum$ as $d_Lapp_api_ClientType$namedEnum$ };
var $n_Lapp_api_ClientType$namedEnum$;
function $m_Lapp_api_ClientType$namedEnum$() {
  if ((!$n_Lapp_api_ClientType$namedEnum$)) {
    $n_Lapp_api_ClientType$namedEnum$ = new $c_Lapp_api_ClientType$namedEnum$();
  }
  return $n_Lapp_api_ClientType$namedEnum$;
}
export { $m_Lapp_api_ClientType$namedEnum$ as $m_Lapp_api_ClientType$namedEnum$ };
function $s_Lapp_api_ClientType$__DesktopBrowser__Lapp_api_ClientType() {
  $m_Lapp_api_ClientType$();
  return $t_Lapp_api_ClientType$__DesktopBrowser;
}
export { $s_Lapp_api_ClientType$__DesktopBrowser__Lapp_api_ClientType as $s_Lapp_api_ClientType$__DesktopBrowser__Lapp_api_ClientType };
function $s_Lapp_api_ClientType$__MobileBrowser__Lapp_api_ClientType() {
  $m_Lapp_api_ClientType$();
  return $t_Lapp_api_ClientType$__MobileBrowser;
}
export { $s_Lapp_api_ClientType$__MobileBrowser__Lapp_api_ClientType as $s_Lapp_api_ClientType$__MobileBrowser__Lapp_api_ClientType };
function $s_Lapp_api_ClientType$__Tauri__Lapp_api_ClientType() {
  $m_Lapp_api_ClientType$();
  return $t_Lapp_api_ClientType$__Tauri;
}
export { $s_Lapp_api_ClientType$__Tauri__Lapp_api_ClientType as $s_Lapp_api_ClientType$__Tauri__Lapp_api_ClientType };
/** @constructor */
function $c_Lapp_api_ClientType$() {
  this.Lapp_api_ClientType$__f_$values = null;
  this.Lapp_api_ClientType$__f_tapirCodec$lzy1 = null;
  this.Lapp_api_ClientType$__f_tapirCodecbitmap$1 = false;
  this.Lapp_api_ClientType$__f_derived$CanEqual$lzy1 = null;
  this.Lapp_api_ClientType$__f_derived$CanEqualbitmap$1 = false;
  $n_Lapp_api_ClientType$ = this;
  $t_Lapp_api_ClientType$__DesktopBrowser = new $j_app$002eapi$002e$002dClient$002dType$0024$0024anon$00241.$c_Lapp_api_ClientType$$anon$1("DesktopBrowser", 0);
  $t_Lapp_api_ClientType$__MobileBrowser = new $j_app$002eapi$002e$002dClient$002dType$0024$0024anon$00241.$c_Lapp_api_ClientType$$anon$1("MobileBrowser", 1);
  $t_Lapp_api_ClientType$__Tauri = new $j_app$002eapi$002e$002dClient$002dType$0024$0024anon$00241.$c_Lapp_api_ClientType$$anon$1("Tauri", 2);
  this.Lapp_api_ClientType$__f_$values = new ($j_app$002eapi$002e$002dClient$002dType.$d_Lapp_api_ClientType.getArrayOf().constr)([$s_Lapp_api_ClientType$__DesktopBrowser__Lapp_api_ClientType(), $s_Lapp_api_ClientType$__MobileBrowser__Lapp_api_ClientType(), $s_Lapp_api_ClientType$__Tauri__Lapp_api_ClientType()]);
}
export { $c_Lapp_api_ClientType$ as $c_Lapp_api_ClientType$ };
$c_Lapp_api_ClientType$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_ClientType$.prototype.constructor = $c_Lapp_api_ClientType$;
/** @constructor */
function $h_Lapp_api_ClientType$() {
}
export { $h_Lapp_api_ClientType$ as $h_Lapp_api_ClientType$ };
$h_Lapp_api_ClientType$.prototype = $c_Lapp_api_ClientType$.prototype;
$c_Lapp_api_ClientType$.prototype.values__ALapp_api_ClientType = (function() {
  var this$1 = this.Lapp_api_ClientType$__f_$values;
  return this$1.clone__O();
});
$c_Lapp_api_ClientType$.prototype.tapirCodec__Lsttp_tapir_Codec = (function() {
  if ((!this.Lapp_api_ClientType$__f_tapirCodecbitmap$1)) {
    var this$1 = $m_Lapp_api_ClientType$namedEnum$();
    this.Lapp_api_ClientType$__f_tapirCodec$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lframework_utils_NamedEnum__tapirCodec__Lsttp_tapir_Codec(this$1);
    this.Lapp_api_ClientType$__f_tapirCodecbitmap$1 = true;
  }
  return this.Lapp_api_ClientType$__f_tapirCodec$lzy1;
});
$c_Lapp_api_ClientType$.prototype.derived$CanEqual__s_CanEqual = (function() {
  if ((!this.Lapp_api_ClientType$__f_derived$CanEqualbitmap$1)) {
    this.Lapp_api_ClientType$__f_derived$CanEqual$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_CanEqual$derived$();
    this.Lapp_api_ClientType$__f_derived$CanEqualbitmap$1 = true;
  }
  return this.Lapp_api_ClientType$__f_derived$CanEqual$lzy1;
});
$c_Lapp_api_ClientType$.prototype.ordinal__O__I = (function(x) {
  return x.Lapp_api_ClientType$$anon$1__f__$ordinal$1;
});
var $d_Lapp_api_ClientType$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_ClientType$, "app.api.ClientType$", ({
  Lapp_api_ClientType$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lapp_api_ClientType$ as $d_Lapp_api_ClientType$ };
var $n_Lapp_api_ClientType$;
function $m_Lapp_api_ClientType$() {
  if ((!$n_Lapp_api_ClientType$)) {
    $n_Lapp_api_ClientType$ = new $c_Lapp_api_ClientType$();
  }
  return $n_Lapp_api_ClientType$;
}
export { $m_Lapp_api_ClientType$ as $m_Lapp_api_ClientType$ };
var $t_Lapp_api_ClientType$__DesktopBrowser = null;
function $u_Lapp_api_ClientType$__DesktopBrowser(x) {
  $t_Lapp_api_ClientType$__DesktopBrowser = x;
}
export { $t_Lapp_api_ClientType$__DesktopBrowser as $t_Lapp_api_ClientType$__DesktopBrowser, $u_Lapp_api_ClientType$__DesktopBrowser as $u_Lapp_api_ClientType$__DesktopBrowser };
var $t_Lapp_api_ClientType$__MobileBrowser = null;
function $u_Lapp_api_ClientType$__MobileBrowser(x) {
  $t_Lapp_api_ClientType$__MobileBrowser = x;
}
export { $t_Lapp_api_ClientType$__MobileBrowser as $t_Lapp_api_ClientType$__MobileBrowser, $u_Lapp_api_ClientType$__MobileBrowser as $u_Lapp_api_ClientType$__MobileBrowser };
var $t_Lapp_api_ClientType$__Tauri = null;
function $u_Lapp_api_ClientType$__Tauri(x) {
  $t_Lapp_api_ClientType$__Tauri = x;
}
export { $t_Lapp_api_ClientType$__Tauri as $t_Lapp_api_ClientType$__Tauri, $u_Lapp_api_ClientType$__Tauri as $u_Lapp_api_ClientType$__Tauri };
//# sourceMappingURL=app.api.-Client-Type$.js.map
